import {
    DIC
} from '@/const/dic'
import {
    formatterTime
} from '@/util/util'
import {
    baseUrl
} from '@/config/env';




export const engineerSaleOrderOption = {
    align: "center",
    menuAlign: "center",
    headerAlign: "center",
    border: true,
    expand: false,
    stripe: false,
    showHeader: true,
    // align: 'center',
    index: false,
    selection: true,
    menu: true,
    page: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    viewBtn: false,
    menuWidth: '300',
    labelWidth: '160',
    //menuType:'menu',
    defaultSort: {
        prop: 'createTime',
        order: 'descending'
    },
    column: [{
            label: "产品名称",
            prop: "goodsName",
            search: true,
            type: "input"
        },
        // {
        //     label: '销售渠道',
        //     type: 'select',
        //     dicData: DIC.PRODUCT_ORDER_TYPE,
        //     search: true
        // },
        {
            label: '品牌名称',
            prop: 'brandName',
        },
        {
            label: '产品型号',
            prop: 'goodsType'
        },
        {
            label: '产品分类',
            prop: 'goodsClassify'
        },
        {
            label: '订单总数量',
            prop: 'orderCount'
        },
        {
            label: '订单总金额',
            prop: 'orderAmount'
        },
        {
            label: '商品折扣总金额',
            prop: 'discountAmount'
        },
        {
            label: '销售总金额',
            prop: 'saleAmount'
        },
        // {
        //     label: '推广佣金总金额',
        //     prop: 'promoteAmount'
        // },
        // {
        //     label: '商品推广佣金总金额',
        //     prop: 'goodsPromoteAmount'
        // },
        // {
        //     label: '产品优惠券总金额',
        //     prop: 'couponAmount'
        // },
        {
            label: '平台抽成总金额',
            prop: 'platformAmount'
        },
        {
            label: '配送费用总金额',
            prop: 'deliveryAmount'
        },
        {
            label: '销售方利润总金额',
            prop: 'profitAmount'
        },
        {
            label: '配送方式',
            prop: 'deliveryType',
            solt: true,
        }

    ]
};